import { PureComponent } from "react";

// import {
//   BarChart,
//   Bar,
//   Tooltip,
//   ResponsiveContainer,
//   YAxis,
//   XAxis,
//   CartesianGrid
// } from "recharts";

// import {
//   StandardTooltip,
//   CustomizedXAxisTick,
// } from "./../../Utils/Utils.js";

export default class YoutubeWhen extends PureComponent {
  render() {
    // const { data } = this.props;
    return null;
    // return (
    //   <ResponsiveContainer height={158}>
    //     <BarChart
    //       data={data.graph}
    //       layout="vertical"
    //       margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
    //     >
    //       <Tooltip
    //         cursor={{ fill: "#eee", opacity: 0.5 }}
    //         content={
    //           <StandardTooltip
    //             render={({ data }) => {
    //               const payload = data(this.props);
    //               if (payload !== null) {
    //                 return (
    //                   <div className="standard-tooltip">
    //                     {Object.keys(payload).map(key => (
    //                       <Fragment key={key}>
    //                         <header className="standard-tooltip__header">
    //                           <span className="standard-tooltip__key-header">
    //                             Demographics
    //                           </span>
    //                         </header>
    //                         <main className="standard-tooltip__main">
    //                           <div className="standard-tooltip__item">
    //                             <span className="standard-tooltip__key">
    //                               <span
    //                                 className="standard-tooltip__icon"
    //                                 style={{ background: "#FA6E57" }}
    //                               />
    //                               <span className="standard-tooltip__value-header">
    //                                 {payload[key].payload.name}
    //                               </span>
    //                             </span>
    //                             <span className="standard-tooltip__value">
    //                               {formatMetric(payload[key].value)}
    //                             </span>
    //                           </div>
    //                         </main>
    //                       </Fragment>
    //                     ))}
    //                   </div>
    //                 );
    //               }
    //             }}
    //           />
    //         }
    //       />
    //       <XAxis
    //         type="number"
    //         axisLine={false}
    //         tickLine={false}
    //         mirror={false}
    //         dataKey="value"
    //         tick={<CustomizedXAxisTick />}
    //       />
    //       <YAxis
    //         type="category"
    //         axisLine={false}
    //         tickLine={false}
    //         mirror={false}
    //         dataKey="name"
    //         interval={0}
    //       />
    //       <CartesianGrid
    //         strokeDasharray="3 3"
    //         horizontal={false}
    //         stroke={"#FC6D52"}
    //         strokeOpacity={0.3}
    //       />

    //       <defs>
    //         <linearGradient
    //           id="colorDemographicBar"
    //           x1="0"
    //           y1="0"
    //           x2="1"
    //           y2="0"
    //         >
    //           <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
    //           <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
    //         </linearGradient>
    //       </defs>

    //       <Bar dataKey="value" fill="url(#colorDemographicBar)" />
    //     </BarChart>
    //   </ResponsiveContainer>
    // );
  }
}
